import { useEffect } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'

import { isSameDay } from 'date-fns'

import { getDocument } from '@/shared/firebase/DocumentsDAO'
import { Reservation } from '@monorepo/functions/src/types/reservations'

import { useCalendarStore } from '../model/store'
import { CalendarGrid } from './CalendarGrid'
import { CalendarHeader } from './CalendarHeader'
import { UnscheduledHairSalonTasks } from './UnscheduledHairSalonTasks'

interface HairSalonCalendarTabProps {
    managingReservationId?: string | null
}

export function HairSalonCalendarTab({ managingReservationId }: HairSalonCalendarTabProps) {
    const { isTouchMode, setSelectedDate, setView, selectedDate, view } = useCalendarStore()

    useEffect(() => {
        const fetchReservation = async () => {
            if (managingReservationId) {
                const reservation = await getDocument<Reservation>({
                    collectionName: 'reservations',
                    id: managingReservationId,
                })
                if (reservation !== undefined) {
                    const reservationDate =
                        reservation.type === 'hotel' ? new Date(reservation.checkInDate) : new Date(reservation.date)
                    if (!isSameDay(selectedDate, reservationDate)) {
                        setSelectedDate(reservationDate)
                    }
                    if (view !== 'week') {
                        setView('week')
                    }
                }
            }
        }
        fetchReservation()
    }, [])

    return (
        <DndProvider backend={isTouchMode ? TouchBackend : HTML5Backend} options={{ enableMouseEvents: true }}>
            <div className='mt-[-10px] flex h-full flex-col'>
                <UnscheduledHairSalonTasks className='mb-4' managingReservationId={managingReservationId} />
                <CalendarHeader />
                <CalendarGrid />
            </div>
        </DndProvider>
    )
}
